import TextInput from "../../../components/inputs/TextInput";
import CheckBoxInput from "../../../components/inputs/CheckBoxInput";
import ResizableShape from "../../../components/dashboard/ResizableShape";
import { imagePreview, user as dummyUserImg } from "../../../helpers/images";
import NameStyleSettings from "./NameStyleSettings";

const SetNamePreferenceForm = ({ formData, setFormData, handleChange }) => {
  const handleHideUsername = (e) => {
    setFormData((prevState) => ({
      ...prevState,
      hideUsername: e.target.checked,
    }));
  };

  const avatarPreviewStyle = {
    position: "absolute",
    background: "rgba(0,0,0,0.8)",
    width: formData.imagePosition?.width,
    height: formData.imagePosition?.height,
    top: formData.imagePosition?.y,
    left: formData.imagePosition?.x,
    borderRadius:
      formData.imageAttribute?.shape?.toLocaleLowerCase() === "circle"
        ? "100%"
        : "",
  };

  return (
    <>
      <form className="min-w-[800px] overflow-y-auto">
        <NameStyleSettings setFormData={setFormData} formData={formData} />
        <TextInput
          id="dummy-name"
          name="sampleUsername"
          value={formData.sampleUsername}
          placeholder="Sample Name"
          onChange={handleChange}
        />

        <CheckBoxInput
          id="hide-username"
          label="Hide name field"
          onChange={handleHideUsername}
        />

        <div className="w-full mt-2 relative max-w-[703px] resive-boundary">
          <div
            className={`absolute bg-[#f4faffcc] p-4 w-full h-full z-[1] ${
              formData.imageAttribute?.height || 100
            } ${formData.imageAttribute?.width || 100}`}
          ></div>
          {!formData.hideUsername && (
            <ResizableShape
              resizeType="nameAttribute"
              attributes={formData?.nameAttribute}
              setFormData={setFormData}
              aspectRatio={0}
              bg="rgba(0,0,0,0.2)"
              shape="square"
              text={formData.sampleUsername.trim() || "Sample Name"}
              zoomable="s, e"
              textStyles={{
                fontFamily: formData.nameAttribute?.fontFamily.value,
                fontSize: `${formData.nameAttribute?.fontSize.value}px`,
                fontStyle: formData.nameAttribute?.fontStyle,
                fontWeight: formData.nameAttribute?.fontWeight,
                justifyContent:
                  formData.nameAttribute?.textAlign === "rpad"
                    ? "flex-end"
                    : formData.nameAttribute?.textAlign === "lpad"
                    ? "flex-start"
                    : "center",
                color: formData.nameAttribute?.textColor,
                textTransform: formData.nameAttribute?.textTransform,
              }}
            />
          )}
          <div style={avatarPreviewStyle} />
          <img
            className="w-full h-full overflow-hidden relative"
            src={formData.bannerData || imagePreview}
            alt="Preview"
          />
          <img
            style={{
              height: formData.imageAttribute.height,
              width: formData.imageAttribute.width,
              left: formData.imageAttribute.x,
              top: formData.imageAttribute.y,
            }}
            src={dummyUserImg}
            className={`absolute z-40 ${
              formData.imageAttribute.shape.toLocaleLowerCase() === "circle"
                ? "rounded-full"
                : "rounded-sm"
            }`}
            alt="where user's face will be"
          />
        </div>
      </form>
    </>
  );
};

export default SetNamePreferenceForm;
